export default {
    canBeStretched: true
}
